// ChoralEditorialDemo.jsx — public read-only preview surface for
// Checkpoint 8 acceptance screenshots. Points at the /preview/admin/*
// endpoints (no auth). Write endpoints stay auth-guarded — the panels
// render in `readOnly` mode so no PATCH/POST is issued.
import React from "react";
import ChoralEditorialWorkspace from "@/features/choral-editorial/ChoralEditorialWorkspace";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/preview/admin/choral`;

export default function ChoralEditorialDemo() {
  return (
    <ChoralEditorialWorkspace
      apiBase={API_BASE}
      statsPath="/stats"
      duplicatesPath="/duplicates"   /* Preview surface has no duplicates route — will 404 silently */
      canVerify={false}
      readOnly={true}
    />
  );
}
